const initialState = {
    fetching: false,
    fetched: false,
    items: [],
    error: null
};

export default function action(state = initialState, action) {
    switch (action.type) {
        case "FETCH_TESTS":
            return { ...state, fetching: action.payload };
        case "FETCH_TESTS_ERROR":
            return { ...state, fetching: false, fetched: false, error: action.payload };
        case "RECEIVE_TESTS":
            return { ...state, fetching: false, fetched: true, items: action.payload };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/tests.js